import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddStorageLocations, UploadStorageLocations } from './storage-locations.interface';

@Injectable({
    providedIn: 'root',
})
export class StorageLocationsService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage.list;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage.listDT;

    private findURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage.find;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage.store;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage.update;

    private deleteUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.storage
            .public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddStorageLocations) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: UploadStorageLocations) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.post(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.post(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
